export class InvoiceExport{
    type?: string;
    delivery?: string;
    from?: string;
    until?: string;
    exportFileType?: Date;
}

export const invoiceDateFormat = 'yyyy-MM-dd';